import CustomFieldValue from 'components/framework/models/CustomFieldValue';
import CustomField from '../CustomField';

export default class SelectConstantCustomField extends CustomField {
  exampleContents() {
    return {
      text: 'Predefined choice list',
    };
  }

  contentsForRecord(record) {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.value) {
      // Predefined choice lists can be shown as text or colored choices, if it's set to show as plain text
      // the query will always return nil for the color, so we detect that here and change our output accordingly
      if (customFieldValue.colorObject) {
        return {
          pill: {
            text: customFieldValue.value,
            color: customFieldValue.colorObject.hex(),
          },
        };
      } else {
        return { text: customFieldValue.value };
      }
    }

    return {};
  }

  buildScope(query) {
    return query.deepMerge({
      customFieldValues: CustomFieldValue.select(
        'key',
        'value',
        'color'
      ).argument({
        ids: this.id,
      }),
    });
  }
}
